import React from 'react'
import { v4 as uuidv4 } from 'uuid'
import { useLocation, useNavigate } from 'react-router-dom'
import PropTypes, { any } from 'prop-types'
import { Box, Button } from '../../../../mui/Core/index'
import { useTheme } from '../../../../mui/Styles/index'

function NavButtons(props) {
  const theme = useTheme()
  const { navLinks, selected } = props
  const navigate = useNavigate()
  const location = useLocation()

  const handleNavigate = (navigateToPath) => () => {
    if (navigateToPath === location.pathname) {
      navigate(0)
    } else {
      navigate(navigateToPath)
    }
  }

  const navButtonsStyle = {
    display: 'flex',
    margin: 'auto',
    width: '100%',
    maxWidth: '770px',
  }

  const navButtonStyle = {
    color: theme.palette.common.white,
    display: 'block',
    textTransform: 'uppercase',
    fontSize: '16px',
    width: '100%',
    whiteSpace: 'nowrap',
    margin: '2px 0 2px 0',
    letterSpacing: '1.28px',
  }

  const navSelectedStyle = {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.secondary.main,
    borderRadius: '20px',
    display: 'block',
    textTransform: 'uppercase',
    fontSize: '16px',
    width: '100%',
    whiteSpace: 'nowrap',
    margin: '2px 0 2px 0',
    letterSpacing: '1.28px',
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
    },
  }

  return (
    <Box sx={navButtonsStyle}>
      {navLinks.map((link) => (
        // The props.selected value is collected in the page that calls the
        // Genericnav and passed through to the NavButtons component.
        // ex:selected="Orders" - if equal to link.title, tab is highlighted
        <Button
          sx={link.title === selected ? navSelectedStyle : navButtonStyle}
          onClick={handleNavigate(link.path)}
          key={uuidv4()}
        >
          {link.title}
        </Button>
      ))}
    </Box>
  )
}

NavButtons.propTypes = {
  navLinks: PropTypes.arrayOf(PropTypes.objectOf(any)).isRequired,
  selected: PropTypes.string,
}

export default NavButtons
